import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { SharedModule } from './../../../shared/shared.module';
import { EditEmployeeRoutingModule } from './edit-employee-routing.module';
import { EditEmployeeComponent } from './edit-employee.component';

@NgModule({
  imports: [CommonModule, NgSelectModule, FormsModule, ReactiveFormsModule, SharedModule, EditEmployeeRoutingModule],
  declarations: [EditEmployeeComponent]
})
export class EditEmployeeModule {}
